import React from "react";
import { Outlet } from 'react-router-dom';

import Header from './HeaderComponent';
import Footer from "./FooterComponent";

const RootLayout = (props) => (
    <React.Fragment>
        <Header
            logoutUser={props.logoutUser}
        />
        <Outlet />
        <Footer />
    </React.Fragment>
  );

  export default RootLayout;